import {
  HomeIcon,
  FolderIcon,
  UserGroupIcon,
  QuestionMarkCircleIcon,
  ClipboardListIcon,
  CreditCardIcon,
  ChatIcon,
  UsersIcon,
  TruckIcon,
  CurrencyDollarIcon,
} from "@heroicons/react/outline";

import Login from "@signin";
import Signup from "@signup";
import SignupUser from "@signupuserdetails";
import Dashboard from "@dashboard";
import Personalinfo from "@personalinfo";
import Badges from "@badges";
import Numberplate from "@numberplate";
import Transaction from "@transaction";
import Cancel from "./components/transactions/components/cancel";
import ResetPassword from "./components/resetpassword/index";
// Languages
import LocaleStrings from "@language";
const lang = LocaleStrings.getLanguage();
console.log("route lang", lang);

var routes = [
  {
    path: "/login",
    name: "",
    icon: FolderIcon,
    component: <Login />,
    display: false,
    key: "login",
    layout: "/auth",
  },
  {
    path: "/signup",
    name: "",
    icon: FolderIcon,
    component: <Signup />,
    display: false,
    key: "signup",
    layout: "/auth",
  },
  {
    path: "/signupuser",
    name: "",
    icon: FolderIcon,
    component: <SignupUser />,
    display: false,
    key: "signupuser",
    layout: "/auth",
  },
  {
    path: "/",
    name: LocaleStrings.dashboard,
    icon: HomeIcon,
    component: <Dashboard />,
    display: false,
    key: "dashboard",
    section: "both",
    layout: "/admin",
  },
  {
    path: "/dashboard",
    name: LocaleStrings.dashboard,
    icon: HomeIcon,
    component: <Dashboard />,
    display: true,
    key: "dashboard",
    section: "both",
    layout: "/admin",
  },

  {
    path: "/personalinfo",
    name: LocaleStrings.personalinfo,
    icon: UsersIcon,
    component: <Personalinfo />,
    display: true,
    key: "personalinfo",
    section: "both",
    layout: "/admin",
  },
  {
    path: "/badges",
    name: LocaleStrings.badges,
    icon: CreditCardIcon,
    component: <Badges />,
    display: true,
    key: "badges",
    section: "both",
    layout: "/admin",
  },
  {
    path: "/numberplate",
    name: LocaleStrings.numberplate,
    icon: TruckIcon,
    component: <Numberplate />,
    display: true,
    key: "numberplate",
    section: "both",
    layout: "/admin",
  },
  {
    path: "/transactions",
    name: LocaleStrings.mytransaction,
    icon: CurrencyDollarIcon,
    component: <Transaction />,
    display: true,
    key: "mytransaction",
    section: "both",
    layout: "/admin",
  },
  {
    path: "/pay-cancel",
    component: <Cancel />,
    display: false,
    key: "pay-cancel",
    section: "both",
    layout: "/admin",
  },
  {
    path: "/resetpassword",
    name: "",
    icon: FolderIcon,
    component: <ResetPassword />,
    display: false,
    key: "resetpassword",
    layout: "/auth",
  },
];
export default routes;
